// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__robotoItalic_eb357c', '__robotoItalic_Fallback_eb357c'","fontWeight":400},"className":"__className_eb357c","variable":"__variable_eb357c"};